import { useEffect } from "react";
import PageMeta from "@/components/PageMeta";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import MarketplaceSection from "@/components/landing/MarketplaceSection";
import ViralSection from "@/components/landing/ViralSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate("/feed", { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading || user) return null;

  return (
    <div className="min-h-screen bg-background landing-page-wrapper">
      <PageMeta title="Gloogum — Social Media, Marketplace & Community Platform" description="The all-in-one platform for social networking, marketplace, events, jobs, dating, live streaming, AI tools & more. Join millions of users today." path="/" />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <MarketplaceSection />
      <ViralSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
